<template>
  <v-flex xs12 class="mt-3 mx-4">
    <v-card id="lender-card-info">
      <lender-list-tile
        class="py-3"
        :logo="lender.companyLogo"
        :title="lender.typeLabel"
        :subtitle="lender.name"
        :active="true"
      />
    </v-card>
  </v-flex>
</template>

<script>
  import LenderListTile from 'Components/LenderListTile.vue'

  export default {
    name: 'LenderCard',
    components: {
      LenderListTile
    },
    props: {
      lender: {
        type: Object,
        default: () => {}
      }
    }
  }
</script>
